<template>
  <div>
    <loader :loading="loading"/>
    <div class="l-row">
      <form-group :label="$t('mercadoLivre.account.label')" :columns="6" :required="true" v-if="mercadoLivreAccounts.length">
        <select v-model="filters.account.identifier" class="form-select">
          <option :value=null>{{ $t('choose.label') }}</option>
          <option v-for="account in mercadoLivreAccounts" :value="account.identifier">{{ `${account.name} (${account.nickname})` }}</option>
        </select>
      </form-group>

      <form-group label="Tipo" :columns="6" :required="true">
        <select class="form-select" v-model="filters.type">
          <option :value=null>{{ $t('choose.label') }}</option>
          <option v-for="type in typeOptions" :key="type" :value="type">{{ $t(`mercadoLivre.types.${type}.label`) }}</option>
        </select>
      </form-group>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import Loader from '@/components/template/Loader'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({
      loading: false,
      typeOptions: [
        'gold_pro',
        'gold_special',
        'free'
      ],
      filters: {
        account: {
          identifier: null
        },
        type: null
      }
    }),
    props: {
      module: {
        type: Object,
        required: true
      }
    },
    mounted () {
      if (!this.mercadoLivreAccounts.length) {
        this.loading = true
        this.fetchAccounts({
          options: {
            active: true
          }
        }).then(() => {
          this.loading = false
        })
      }
    },
    methods: {
      ...mapActions('mercadoLivreAccounts', [
        'fetchAccounts'
      ])
    },
    computed: {
      ...mapFields({
        mercadoLivreAccounts: 'mercadoLivreAccounts.accounts'
      })
    },
    components: {
      FormGroup,
      Loader
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// MercadoLivre.vue?6b24ad2f